import { NeverDepth } from 'three';
import { useAsset } from '@artica/assets';

export default function ParticleScape() {
  const particles = useAsset('dyson_particles');

  return (
    <sprite scale={ 3000.6 }>
      <spriteMaterial
        alphaMap={ particles }
        color={ [2.5, 2.6, 6] }
        map={ particles }
        opacity={ 1 }
        depthFunc={ NeverDepth }
        sizeAttenuation={ true }
        fog={ false }
        depthWrite={ false }
        alphaTest={ 0.002 }
        transparent
      />
    </sprite>
  );
};